import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import instamapsMessageModal from '../shared/components/message-modal/message-modal.vue';
import messages from './registre-translations';
import { RegistreService } from './services/registreService';

export default {
    name: 'instamapsRegistre',
    data: () => {
        return {
            modalIsError: false,
            modalIsLoaded: false,
            modalTitle: "",
            modalMessage: "",
            form: {
                email: '',
                username: '',
                name: '',
                surname: '',
                pass: '',
                confirmpass: '',
            },
        };
    },
    i18n: {
        messages,
    },
    components: {
        instamapsBreadcrumbs,
        instamapsMessageModal,
    },
    props: {
        hasBreadcrumbs: { type: Boolean },
        selectedLang: { type: String },
    },
    methods: {
        registre(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                  RegistreService.registre(this.form, this.selectedLang).then((response) => {
                    if (response) {
                        this.sendEmailConfirmacio();
                        this.showModalOK();
                    }else{
                        this.showModalError();
                    }
                  }).catch(() => {
                    this.showModalError();
                  });
                }else{
                    this.showModalError();
                }
            });
        },
        loaded: function(){
            if(!this.modalIsError){
                this.$emit('toLogin');
            }
            this.modalIsError = false;
            this.modalIsLoaded = false;
        },
        showModalError: function(){
            this.modalTitle = this.$t('titleErrorRegistre');
            this.modalMessage = this.$t('messageErrorRegistre');
            this.modalIsError = true;
            this.modalIsLoaded = true;
        },
        showModalOK: function(){
            this.modalTitle = this.$t('titleOkRegistre');
            this.modalMessage = this.$t('messageOkRegistre');
            this.modalIsError = false;
            this.modalIsLoaded = true;
            window.dataLayer.push({
                'event': 'registreOK',
                'email': this.form.email
            });
        },
        sendEmailConfirmacio: function(){
            //Enviar mail confirmació de registre
            var email = this.form.email;
            var contingut= this.createContingutEmail(email);//this.$t("Registre completat correctament");
            var subject = this.$t('subject');
            RegistreService.sendMailRegistre(email, subject, contingut);
        },
        createContingutEmail: function(email){
            //console.debug("Create contingut email....");
            //console.debug(email);
            var uid = email.split("@");
            
            var user = (uid[0]?uid[0]:email);
            //console.debug(user);
            var contingut = "<br><br>";
            contingut+= this.$t("hola");
            contingut+= " "+user+",<br><br>";
            contingut+= this.$t("registreExit");
            contingut+= "<br>";
            contingut+= this.$t("registreBenvinguda");
            contingut+= "<br>";
            contingut+= "<br>";
            contingut+= this.$t("registreFaqs");
            contingut+= "<br>";
            contingut+= "<a href=\"http://betaportal.icgc.cat/wordpress/faq-dinstamaps/\" target=\"_blank\">http://betaportal.icgc.cat/wordpress/faq-dinstamaps/</a>";
            contingut+= "<br>";
            contingut+= "<br>";
            contingut+= this.$t("registreBetaportal");
            contingut+= "<br>";
            contingut+= "<a href=\"http://betaportal.icgc.cat/wordpress/category/instamaps/\" target=\"_blank\">http://betaportal.icgc.cat/wordpress/category/instamaps/</a>";		
            contingut+= "<br>";
            contingut+= "<br>";
            contingut+= this.$t("registreGaleria");
            contingut+= "<br>";
            contingut+= "<a href=\"http://www.instamaps.cat/geocatweb/galeria.html\" target=\"_blank\">http://www.instamaps.cat/geocatweb/galeria.html</a>";
            contingut+= "<br>";
            contingut+= "<br>";
            contingut+= this.$t("registreAjuda");
            contingut+= "<br>";
            contingut+= "<a href=\"https://icgc.cat/Registre\" target=\"_blank\">https://icgc.cat/Registre</a>. ";
            contingut+= "<br>";
            contingut+= "<br>";
            contingut+= this.$t("registreContacte");
            contingut+= "<a href=\"mailto:instamaps@icgc.cat\" target=\"_blank\">instamaps@icgc.cat</a>. ";
            contingut+= this.$t("registreFeedback");
            contingut+= "<br>";
            contingut+= "<br>";
            //console.debug(contingut);
            return contingut;
        }
    },
};



// WEBPACK FOOTER //
// ./src/registre/registre.js